module.exports = __webpack_public_path__ + "static/img/JoshAddoCarr.cb7b433.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JoshAddoCarr.jpg
// module id = Ta3R
// module chunks = 0